/**
 * Marks the Indy composer so other surfaces can tell when it holds focus.
 *
 * Indy's push-to-talk (`usePushToTalk`) and Assessment's double-tap
 * (`useDoubleTapKey`) both listen to bare Control, and the Indy panel floats
 * over the appointment page — so both can be live at once. The hold and the
 * double-tap are disjoint gestures, but a Control press inside the composer
 * belongs to Indy either way, and the two share one dictation manager. This
 * marker is how Assessment stands its gesture down there.
 *
 * Its own module (no deps) rather than an export from `ChatComposer`, so the
 * Assessment bundle does not pull the whole chat surface in to read a string.
 */

/** Attribute stamped on the element wrapping the Indy composer. */
export const INDY_COMPOSER_ATTRIBUTE = "data-indy-composer";

/** Whether focus is inside the Indy composer right now. */
export function isIndyComposerFocused(): boolean {
  const active = document.activeElement;
  return (
    active instanceof Element &&
    active.closest(`[${INDY_COMPOSER_ATTRIBUTE}]`) !== null
  );
}
